/**
 * Demo / local email pipeline: skip `POST …/emails` and simulate delivery + fake inbound replies.
 *
 * - Explicit: `REACT_APP_ADMIN_EMAIL_MOCK=true` | `false`
 * - **Unset:** **off** — admin send uses the real API (same as production). Set `=true` only for UI demos
 *   without a mail worker / backend queue.
 */
function parseFlag(raw) {
  if (raw == null) return null;
  const s = String(raw).toLowerCase().trim();
  if (s === "" || s === "undefined") return null;
  if (s === "true" || s === "1" || s === "yes") return true;
  if (s === "false" || s === "0" || s === "no") return false;
  return null;
}

export function isAdminEmailMockTransportEnabled() {
  const parsed = parseFlag(process.env.REACT_APP_ADMIN_EMAIL_MOCK);
  if (parsed !== null) return parsed;
  return false;
}
